import { Agent } from "../model_gen/agent";
import { ApplicationAction } from "../model_gen/application";
import { GeneralService } from "./GeneralService";

export class AgentService {
  
  /**
   * Get all agents for an application
   */
  static getAgentsByApplication(
    applicationId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.get(
      `/agent/${applicationId}/agents`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Create a new agent
   */
  static createAgent(
    agent: Partial<Agent>,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.post(
      "/agent/agents",
      JSON.stringify(agent),
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Get agent details by ID
   */
  static getAgent(
    agentId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.get(
      `/agent/agents/${agentId}`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Update an agent
   */
  static updateAgent(
    agentId: number,
    updates: Partial<Agent>,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.put(
      `/agent/agents/${agentId}`,
      JSON.stringify(updates),
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Delete an agent
   */
  static deleteAgent(
    agentId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.delete(
      `/agent/agents/${agentId}`,
      "",
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Get all intents for an agent
   */
  static getAgentIntents(
    agentId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.get(
      `/agent/agents/${agentId}/intents`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Assign intent to agent
   */
  static assignIntentToAgent(
    agentId: number,
    intentId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.post(
      `/agent/agents/${agentId}/intents`,
      JSON.stringify({ intent_id: intentId }),
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Remove intent from agent
   */
  static removeIntentFromAgent(
    agentId: number,
    intentId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.delete(
      `/agent/agents/${agentId}/intents/${intentId}`,
      "",
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Get intents without agents for an application
   */
  static getOrphanedIntents(
    applicationId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.get(
      `/agent/${applicationId}/orphaned-intents`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Get detailed statistics for an agent
   */
  static getAgentStatistics(
    agentId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.get(
      `/agent/agents/${agentId}/statistics`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
} 